import { trackOpenForbiddenTextPopup } from './tracking';
import { currentChatOpponentIdSelector } from '../../selectors';
import { showAlert } from '../../slices/alertSlice';
import { EAlert } from '../../types/alert';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { createWsMessage } from '../../utils/message';
import { deleteMessageFromChat, setSendMessageFailed } from '../sendMessage';
import { IWsModalErrorEvent } from './types';

export const setWsModalError =
  (event: IWsModalErrorEvent): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { telemetry, custom: { messagesMap, socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents } = socket;

    const state = getState();

    const { uid, modalMessage } = event;
    const clientEvent = clientEvents.get(uid);
    const opponentId = currentChatOpponentIdSelector(state);

    if (!clientEvent) {
      return;
    }

    clientEvents.set(uid, { ...clientEvent, status: ERequestApiStatus.Failed });

    const messageItem = messagesMap.get(uid);

    if (clientEvent.type !== EWsClientEventType.Message || !messageItem) {
      return;
    }

    const {
      message: {
        message: { message: text, userId },
        chatId,
      },
    } = messageItem;

    if (modalMessage) {
      telemetry.increment(ETelemetryEvents.ChatWsMessageSendFail);
      telemetry.increment(ETelemetryEvents.ChatWsMessageGetModalWarning);
      dispatch(deleteMessageFromChat({ chatId, messageId: uid, messagesMap }));
      clientEvents.delete(uid);
      dispatch(
        showAlert({
          type: EAlert.MessageСontainsForbiddenText,
          modalWarning: modalMessage,
          message: text,
          chatId,
        }),
      );
      trackOpenForbiddenTextPopup(opponentId);

      return;
    }

    const message = createWsMessage({ text, chatId, userId });
    dispatch(setSendMessageFailed({ message, messageId: uid, messagesMap }));
  };
